export const advertizerApiHost = process.env.REACT_APP_ADVERTIZER_API_HOST || 'http://localhost:3001';